export const TEXT_MASK_PATTERN = /[^a-zA-Zа-яА-Я ]/g;
